import React from "react";
import parse from "html-react-parser";
import ReactDOM from "react-dom";
import QRCode from "react-qr-code";
import './accordion.scss'

const AccordionContent = ({
  accordionData,
  activeAccordionId,
  accordionId,
  cssVariableValues,
  QR,
  calcHtmlElementNoWrapWidth,
   handleHotspotClick,
}) => {
  const isArpopup = accordionData.id === "arpopup";

  // ---------------------------
  // Check if content exists
  // ---------------------------
  const hasContent = Array.isArray(accordionData.content)
    ? accordionData.content.length > 0
    : accordionData.content && accordionData.content.toString().trim() !== "";

  // console.log(accordionData.hotspotDataInfo)

  const hasHotspotContent = accordionData.hotspotDataInfo && accordionData.hotspotDataInfo.length > 0;

  const shouldRender = isArpopup || hasContent || hasHotspotContent;
  if (!shouldRender) return null;
  // ---------------------------
  // Popup style based on media
  // ---------------------------
  const listMedia = accordionData.media ? accordionData.media[0] : {};
  const resolution = window.UiUtils.getResolution();
  const desktopPopupLeft = listMedia[resolution]?.left || 0;
  const desktopPopupRight = listMedia[resolution]?.right || 0;
  const desktopPopupTop = listMedia[resolution]?.top || 0;
  const desktopPopupWidth = listMedia[resolution]?.width || 0;
  const desktopPopupHeight = listMedia[resolution]?.height || 0;

  const popupStyle = {
    left: `calc(0px + ${desktopPopupLeft})`,
    right: desktopPopupRight,
    top: desktopPopupTop,
    width: desktopPopupWidth,
    height: desktopPopupHeight,
  };



  // ---------------------------
  // Mobile and iPad rendering
  // ---------------------------
  if (window.isMobIsipadIsPotrait) {
    if (
      accordionData.id === activeAccordionId &&
      (hasContent || hasHotspotContent)
    ) {
      return (
        <div className="accordionCallout">
          {/* Accordion main content */}
          {hasContent && (
            <>
              <h2 className="accordionCalloutHeading">
                {parse(accordionData.popupHeading || accordionData.title)}
              </h2>
              {Array.isArray(accordionData.content) ? (
                <ul className="accordionUnorderList">
                  {accordionData.content.map(
                    (item, i) => item.text && <li key={i}>{parse(item.text)}</li>
                  )}
                </ul>
              ) : (
                <p>{parse(accordionData.content)}</p>
              )}
            </>
          )}

          {/* Hotspot content with click functionality */}
          {hasHotspotContent &&
            accordionData.hotspotDataInfo.map((hotspot, idx) => {
              const hasHotspotContent = Array.isArray(hotspot.content) && hotspot.content.length > 0;
              if (!hasHotspotContent) return null;

              return (
                <div
                  key={idx}
                  className="accordionCallout hotspotCallout"
                  role="button"
                  tabIndex={0}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleHotspotClick?.(accordionData.id, accordionData.hotspotDataInfo, true, hotspot.hsname);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") handleHotspotClick?.(accordionData.id, accordionData.hotspotDataInfo, true, hotspot.hsname);
                  }}
                >
                  {hotspot.popupHeading && <h2 className="accordionCalloutHeading">{parse(hotspot.popupHeading)}</h2>}
                  <ul className="accordionUnorderList">
                    {hotspot.content.map((item, i) => item.text && <li key={i}
                     >{parse(item.text)}</li>)}
                  </ul>
                </div>
              );
            })
          }

        </div>
      );
    }
  }


  // ---------------------------
  // Desktop rendering (unchanged)
  // ---------------------------
  if ((window.deviceBasedonBodyClass === "desktop" ||
    window.deviceBasedonBodyClass === "ipadDesktopLandscape" ||
    window.deviceBasedonBodyClass === "ipadLandscape" ||
    window.deviceBasedonBodyClass === "androidTabLandscape") && hasContent) {
    return ReactDOM.createPortal(
      <div
        role="dialog"
        className={`popup ${isArpopup ? "qrcodeshow" : ""} ${hasContent && accordionData.id === activeAccordionId ? "active" : ""
          }`}
        id={accordionData.popupId || accordionId}
        data-id={accordionId}
        aria-modal="true"
        tabIndex={-1}
        style={popupStyle}
      >
        {Array.isArray(accordionData.content) && accordionData.content.length > 0 && (
          <h2>{parse(accordionData.popupHeading || accordionData.title)}</h2>
        )}
        <div className="content">
          {isArpopup && (
            <div className="qrContainer">
              <QRCode
                size={190}
                value={window.linkForGenerateQR}
                style={{ height: "auto" }}
                className="qrImage"
                aria-hidden="true"
              />
              <span
                className="text"
                data-contentwidth={calcHtmlElementNoWrapWidth(
                  QR,
                  cssVariableValues.qrTextFontSize
                )}
              >
                {QR || ""}
              </span>
            </div>
          )}

          {Array.isArray(accordionData.content) ? (
            <ul>
              {accordionData.content.map(
                (item, i) => item.text && <li key={i}>{parse(item.text)}</li>
              )}
            </ul>
          ) : (
            hasContent && <p>{parse(accordionData.content)}</p>
          )}
        </div>
      </div>,
      document.getElementById("popupContainer")
    );
  }

};

export default AccordionContent;
